import { useEffect, useRef, useCallback } from "react";
import { useLocation } from "wouter";

function getSessionId(): string {
  let sid = sessionStorage.getItem("va_sid");
  if (!sid) {
    sid = Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem("va_sid", sid);
  }
  return sid;
}

export function trackEvent(eventType: string, eventLabel?: string, path?: string) {
  try {
  const sessionId = getSessionId();
  fetch(`${import.meta.env.BASE_URL}api/analytics/event`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sessionId, eventType, eventLabel, path: path || window.location.pathname }),
  }).catch(() => {});
  } catch { /* Analytics must never prevent an enquiry or navigation. */ }
}

export function useAnalytics() {
  const [location] = useLocation();
  const lastTracked = useRef("");

  useEffect(() => {
    if (location.startsWith("/admin")) return;
    if (location === lastTracked.current) return;
    lastTracked.current = location;

    const sessionId = getSessionId();

    const payload = {
      sessionId,
      path: location,
      referrer: document.referrer || undefined,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
    };

    fetch(`${import.meta.env.BASE_URL}api/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => {});
  }, [location]);

  useEffect(() => {
    if (!location.startsWith("/sauna/")) return;
    trackEvent("sauna_page_view", "Sauna page", location);
    const click = (event: MouseEvent) => {
      const link = event.target instanceof Element ? event.target.closest("a") : null;
      if (!link) return;
      const href = link.getAttribute("href") || "";
      if (href.startsWith("tel:")) trackEvent("sauna_call_click", "Sauna page", location);
      else if (href.startsWith("mailto:")) trackEvent("sauna_email_click", "Sauna page", location);
      else if (href.includes("/quote")) trackEvent("sauna_quote_click", "Sauna page", location);
    };
    document.addEventListener("click", click);
    return () => document.removeEventListener("click", click);
  }, [location]);
}
